const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i;

export function resolveImageSrc(src) {
  if (!src) {
    return src;
  }

  const trimmed = String(src).trim();
  if (!trimmed) {
    return trimmed;
  }

  if (ABSOLUTE_URL_PATTERN.test(trimmed) || trimmed.startsWith("data:") || trimmed.startsWith("blob:")) {
    return trimmed;
  }

  const publicUrl = process.env.PUBLIC_URL || "";
  const normalizedPublicUrl = publicUrl.endsWith("/") ? publicUrl.slice(0, -1) : publicUrl;
  const relativePath = trimmed.startsWith("./") ? trimmed.slice(2) : trimmed;

  if (relativePath.startsWith("/")) {
    return `${normalizedPublicUrl}${relativePath}`;
  }

  return `${normalizedPublicUrl}/${relativePath}`;
}
